import eventCategories from '@/constant/eventCategories'

export const NO_CHAT_ROUTES = [
  '2022WrapUp',
  'PresentationShare',
  'PresentationPlayDemo',
  'PresentationBackstage',
  'TemplateView',
]

export const DISALLOWED_ROUTES_FOR_SKOLETUBE = [
  'Team',
  'UserProfile',
  'UserPlan',
  'Upgrade',
  'BillingList',
  'BillingDetail',
  'WhiteLabel',
]

export const ROUTE_NAMES = {
  HOME: 'Home',
  TRASH_BIN: 'TrashBin',
  MSTEAMS_TABCONFIG: 'MSTeams-TabConfig',
  MSTEAMS_PRESENTING: 'MSTeams-Presenting',
  ZOOM_APP: 'ZoomApp',
  ZOOM_PRESENTATION_LIST: 'ZoomPresentationList',
  ZOOM_AUDIENCE_APP: 'ZoomAudienceApp',
  PRESENTATIONS: 'Presentations',
  SHARED_WITH_ME: 'SharedWithMe',
  FOLDER_DETAIL: 'FolderDetail',
  SHARE_FOLDER_DETAIL: 'ShareFolderDetail',
  TEAM_FOLDER_DETAIL: 'TeamFolderDetail',
  TEMPLATE_LIBRARY: 'TemplateLibrary',
  TEMPLATE_CATEGORY: 'TemplateCategory',
  TEAM: 'Team',
  TEAM_MEMBER: 'TeamMember',
  USER_PROFILE: 'UserProfile',
  BILLING_LIST: 'BillingList',
  BILLING_DETAIL: 'BillingDetail',
  COMMUNITY: 'Community',
  UPGRADE: 'Upgrade',
  UPGRADE_BULK_SUCCESS: 'UpgradeBulkSuccess',
  UPGRADE_SUCCESS: 'UpgradeSuccess',
  STRIPE_TRANSITION: 'StripeTransition',
  USER_PLAN: 'UserPlan',
  PRESENTATION_REPORT: 'PresentationReport',
  SHARED_REPORT: 'SharedReport',
  INTEGRATIONS: 'Integrations',
  INTEGRATIONS_DETAIL: 'IntegrationsDetail',
  WHITE_LABEL: 'WhiteLabel',
  REFERRAL: 'Referral',
  DEMO_PRESENTATION: 'DemoPresentation',
  SSO: 'SSO',
  AUTH: 'Auth',
  LOGIN: 'Login',
  REGISTER: 'Register',
  FORGOT_PASSWORD: 'ForgotPassword',
  TOKEN: 'Token',
  ERROR_404: 'Error404',
  CLEAR_TOKEN: 'ClearToken',
  REPORT_SESSION: 'SessionsReport',
  REPORT_QUESTION: 'QuestionsReport',
  PARTICIPANT_PROFILES: 'ParticipantProfiles',
  PRESENTATION_DETAIL: 'PresentationDetail',
  PRESENTATION_BACKSTAGE: 'PresentationBackstage',
  PRESENTATION_SHARE: 'PresentationShare',
  TEMPLATE_VIEW: 'TemplateView',
  TEMPLATE_PREVIEW: 'TemplatePreview',
  PRESENTATION_PLAY_DEMO: 'PresentationPlayDemo',
  SAVE_PRESENTATION: 'SavePresentation',
  GOOGLE_REDIRECT: 'googleRedirect',
  GOOGLE_AUTH: 'googleAuth',
  PRESENTATION_DETAIL_GOOGLE_SLIDE: 'PresentationDetailGoogleSlide',
  PRESENTATION_ERROR_GOOGLE_SLIDE: 'PresentationErrorGoogleSlide',
  GOOGLE_DRIVE_SHORTCUT: 'GoogleDriveShortcut',
  INQUIRIES_FORM: 'InquiriesForm',
  ZOHO_AUTH: 'ZohoAuth',
  CONFIRM_OPENAI: 'ConfirmOpenAI',
  ADMIN_ANALYTICS: 'AdminAnalytics',
  DIRECT_BULK_PURCHASE: 'BulkPurchaseRedirect',
  PRESENTING_EXPERIENCE_SURVEY: 'PresentingExperienceSurvey',
}

export const EXCLUDED_SHOWING_TOASTS_ROUTES = [
  ROUTE_NAMES.PRESENTATION_SHARE,
]

export const PUBLIC_ROUTES = [
  'Login',
  'Token',
  'Register',
  'ForgotPassword',
  'PresentationShare',
  'DemoPresentation',
  'Auth',
  'SSO',
  'PresentationPlayDemo',
  'SavePresentation',
  'MSTeams-TabConfig',
  'MSTeams-Auth',
  'MSTeams-Presenting',
  'ZoomApp',
  'ZoomAudienceApp',
  'googleRedirect',
  'googleAuth',
  'ClearToken',
  'GoogleDriveShortcut',
  'TemplateView',
  ROUTE_NAMES.SHARED_REPORT,
]

export const SURVEY_ROUTES_NAME = [
  ROUTE_NAMES.PRESENTING_EXPERIENCE_SURVEY,
]

export const OPEN_ROUTES_FOR_GUEST = [...PUBLIC_ROUTES, 'PresentationDetail']

// I used Chatgpt for this, so please verify the key and value before using it.
// Make changes if needed.
export const EVENT_CATEGORIES_BY_ROUTE_NAME = {
  [ROUTE_NAMES.HOME]: eventCategories.HOME,
  [ROUTE_NAMES.MSTEAMS_TABCONFIG]: eventCategories.MS_TEAMS_APP,
  [ROUTE_NAMES.MSTEAMS_PRESENTING]: eventCategories.MS_TEAMS_APP,
  [ROUTE_NAMES.ZOOM_APP]: eventCategories.INTEGRATIONS,
  [ROUTE_NAMES.ZOOM_PRESENTATION_LIST]: eventCategories.PRESENTATION_LIST,
  [ROUTE_NAMES.ZOOM_AUDIENCE_APP]: eventCategories.PRESENTING_MODE,
  [ROUTE_NAMES.PRESENTATIONS]: eventCategories.PRESENTATION_LIST,
  [ROUTE_NAMES.SHARED_WITH_ME]: eventCategories.SHARE_WITH_ME,
  [ROUTE_NAMES.FOLDER_DETAIL]: eventCategories.PRESENTATION_LIST,
  [ROUTE_NAMES.SHARE_FOLDER_DETAIL]: eventCategories.SHARE_WITH_ME,
  [ROUTE_NAMES.TEAM_FOLDER_DETAIL]: eventCategories.MY_TEAM,
  [ROUTE_NAMES.TEMPLATE_LIBRARY]: eventCategories.TEMPLATE_LIBRARY,
  [ROUTE_NAMES.TEMPLATE_CATEGORY]: eventCategories.CATEGORY_PUBLIC_TEMPLATE_LISTING,
  [ROUTE_NAMES.TEAM]: eventCategories.MY_TEAM,
  [ROUTE_NAMES.TEAM_MEMBER]: eventCategories.MY_TEAM,
  [ROUTE_NAMES.USER_PROFILE]: eventCategories.MY_ACCOUNT,
  [ROUTE_NAMES.BILLING_LIST]: eventCategories.PAYMENT,
  [ROUTE_NAMES.BILLING_DETAIL]: eventCategories.PAYMENT,
  [ROUTE_NAMES.COMMUNITY]: eventCategories.INTEGRATIONS,
  [ROUTE_NAMES.UPGRADE]: eventCategories.UPGRADE_PLAN,
  [ROUTE_NAMES.USER_PLAN]: eventCategories.MY_PLAN,
  [ROUTE_NAMES.PRESENTATION_REPORT]: eventCategories.PRESENTATION_REPORT,
  [ROUTE_NAMES.INTEGRATIONS]: eventCategories.INTEGRATIONS,
  [ROUTE_NAMES.INTEGRATIONS_DETAIL]: eventCategories.INTEGRATIONS,
  [ROUTE_NAMES.WHITE_LABEL]: eventCategories.INTEGRATIONS,
  [ROUTE_NAMES.REFERRAL]: eventCategories.REFER_FRIEND,
  [ROUTE_NAMES.DEMO_PRESENTATION]: eventCategories.CATEGORY_PUBLIC_TEMPLATE_DEMO_MODE,
  [ROUTE_NAMES.SSO]: eventCategories.PRESENTER_LOGIN,
  [ROUTE_NAMES.AUTH]: eventCategories.PRESENTER_LOGIN,
  [ROUTE_NAMES.LOGIN]: eventCategories.PRESENTER_LOGIN,
  [ROUTE_NAMES.REGISTER]: eventCategories.PRESENTER_REGISTER,
  [ROUTE_NAMES.FORGOT_PASSWORD]: eventCategories.PRESENTER_FORGOTPASSWORD,
  [ROUTE_NAMES.TOKEN]: eventCategories.MY_ACCOUNT,
  [ROUTE_NAMES.ERROR_404]: eventCategories.HOME,
  [ROUTE_NAMES.CLEAR_TOKEN]: eventCategories.MY_ACCOUNT,
  [ROUTE_NAMES.PRESENTATION_DETAIL]: eventCategories.PRESENTATION_EDITOR,
  [ROUTE_NAMES.PRESENTATION_BACKSTAGE]: eventCategories.PRESENTATION_BACKSTAGE,
  [ROUTE_NAMES.PRESENTATION_SHARE]: eventCategories.PRESENTING_MODE,
  [ROUTE_NAMES.TEMPLATE_PREVIEW]: eventCategories.PRESENTATION_PREVIEW,
  [ROUTE_NAMES.PRESENTATION_PLAY_DEMO]: eventCategories.PRESENTING_MODE,
  [ROUTE_NAMES.SAVE_PRESENTATION]: eventCategories.PRESENTATION_EDITOR,
  [ROUTE_NAMES.GOOGLE_REDIRECT]: eventCategories.MY_ACCOUNT,
  [ROUTE_NAMES.GOOGLE_AUTH]: eventCategories.PRESENTER_LOGIN,
  [ROUTE_NAMES.ADMIN_ANALYTICS]: eventCategories.ADMIN_ANALYTICS,
}

export default {
  NO_CHAT_ROUTES,
  PUBLIC_ROUTES,
  OPEN_ROUTES_FOR_GUEST,
  DISALLOWED_ROUTES_FOR_SKOLETUBE,
}
